<header class="bg-header bg-no-repeat h-[466px] bg-cover">
  <div class="flex justify-center flex-col items-center h-[466px] w-full">
    <div class="bg-[#003869] w-8/12 m-2 p-2 ">
      <h2
        class="text-white text-center font-poppins md:text-5xl text-3xl mt-0 mb-2 font-bold tracking-wider
        leading-[2.5rem]">
        Fale Francês em
        <br />
        3 meses
      </h2>
    </div>
    <div class="bg-[#003869] w-8/12 m-2 p-2">
      <p class="text-white text-center font-poppins text-[19px] font-medium">
        Mesmo que você não saiba nada ou ache uma língua difícil
      </p>
    </div>
  </div>
</header>
